import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

import { useGeckoPermissions } from './useGeckoPerms'

export const useEasterEggs = () => {
  const { hasPermissions } = useGeckoPermissions()
  const today = new Date()
  // April 1st - month is zero indexed, date is not ಠ_ಠ
  const isAprilFools = today.getMonth() === 3 && today.getDate() === 1
  const isInternalAprilFools =
    hasPermissions([PERMISSION_GECKO_INTERNAL_MEMBER]) && isAprilFools
  return { isInternalAprilFools, isAprilFools }
}
